import Slider from "react-slick"
import { sliderSettings } from "components/atoms/SliderSettings"
import H2 from "components/atoms/H2"
import useTranslations from "hooks/useTranslations"
import Button from "components/buttons/Button"
import { StaticImage } from "gatsby-plugin-image"
import { useContext, useEffect, useState } from "react"
import cc from "classcat"
import ScrollAnimate from "components/atoms/common/ScrollAnimate"
import CardFlip from "components/atoms/common/CardFlip"
import { LocaleContext } from "../../contexts"

function countDefinedStrings(list) {
  const definedStrings = list.filter(
    (element) => typeof element !== "undefined",
  )
  return definedStrings.length
}

const Card = ({ Image, title, text, theme, back }) => {
  const [cardFlipped, setCardFlipped] = useState(false)

  // useEffect(() => {
  //   const interval = setTimeout(() => {
  //     setInterval(() => {
  //       setCardFlipped((prevState) => !prevState)
  //     }, 6000)
  //   }, back * 250)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // }, [])

  const handleInteractionStart = () => {
    setCardFlipped(true)
  }
  const handleInteractionEnd = () => {
    setCardFlipped(false)
  }

  return (
    <div className="mb-8" key={title}>
      <div
        className="relative mb-6"
        onMouseEnter={handleInteractionStart}
        onMouseLeave={handleInteractionEnd}
        onTouchStart={handleInteractionStart}
        onTouchEnd={handleInteractionEnd}
      >
        <CardFlip flipped={cardFlipped}>
          <div className="flex justify-center">
            <Image />
          </div>
        </CardFlip>
        <div
          className="absolute inset-0 flex items-center justify-center rounded-2xl"
          style={{ backfaceVisibility: "hidden", rotateY: 180 }}
        >
          <CardFlip flipped={!cardFlipped}>
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-kkm-red">
              <h2 className="mb-0 mt-2 select-none text-6xl text-zinc-100">
                {back}
              </h2>
            </div>
          </CardFlip>
        </div>
      </div>
      <div className="mt-2 block">
        <p
          className={cc([
            "m-0 font-display text-lg font-semibold leading-6",
            {
              "text-zinc-900": theme !== "dark",
              "text-gray-200": theme === "dark",
            },
          ])}
        >
          {title}
        </p>
        <p
          className={cc([
            "m-0 mt-3 text-sm",
            {
              "text-zinc-800": theme !== "dark",
              "text-gray-200": theme === "dark",
            },
          ])}
        >
          {text}
        </p>
      </div>
    </div>
  )
}
const ListItem = ({ Image, title, text, theme, back }) => {
  const [cardFlipped, setCardFlipped] = useState(false)
  const handleInteractionStart = () => {
    setCardFlipped(true)
  }
  const handleInteractionEnd = () => {
    setCardFlipped(false)
  }
  return (
    <div
      className="pr-4"
      key={title}
      // onClick={() => setCardFlipped(!cardFlipped)}
      onMouseEnter={handleInteractionStart}
      onMouseLeave={handleInteractionEnd}
      onTouchStart={handleInteractionStart}
      onTouchEnd={handleInteractionEnd}
    >
      <div className="relative mb-6">
        <div className="flex justify-center">
          <Image />
        </div>
      </div>
      <div className="mt-2 block">
        <p
          className={cc([
            "m-0 text-center font-display text-lg font-semibold leading-6",
            {
              "text-zinc-900": theme !== "dark",
              "text-gray-200": theme === "dark",
            },
          ])}
        >
          {title}
        </p>
        <p
          className={cc([
            "text-md m-0 mt-3 text-center",
            {
              "text-zinc-800": theme !== "dark",
              "text-gray-200": theme === "dark",
            },
          ])}
        >
          {text}
        </p>
      </div>
    </div>
  )
}

const Image1 = () => (
  <StaticImage
    src="../../images/howitworks/AdobeStock_385495884.jpeg"
    alt=""
    objectFit="cover"
    className="isolate aspect-square overflow-hidden rounded-xl"
    width={200}
  />
)

const Image2 = () => (
  <StaticImage
    src="../../images/howitworks/AdobeStock_425568426.jpeg"
    alt=""
    objectFit="cover"
    className="isolate aspect-square overflow-hidden rounded-xl"
    width={200}
  />
)

const Image3fi = () => (
  <StaticImage
    src="../../images/howitworks/hand-phone-answer-fi.jpg"
    alt=""
    objectFit="cover"
    className="isolate aspect-square overflow-hidden rounded-xl"
    width={200}
  />
)

const Image3se = () => (
  <StaticImage
    src="../../images/howitworks/hand-phone-answer-se.jpg"
    alt=""
    objectFit="cover"
    className="isolate aspect-square overflow-hidden rounded-xl"
    width={200}
  />
)

const CustomPaging = ({ number, theme }) => {
  return (
    <div className="dot-wrapper">
      <p className={cc([theme, "text-white"])}>{number + 1}</p>
    </div>
  )
}

export const HowItWorks2 = ({
  translations,
  titleAlign = "center",
  images = {},
  theme = "green",
}) => {
  const { appLink } = useTranslations()
  const { locale } = useContext(LocaleContext)

  const list = [
    {
      Image: images.Image1 || Image1,
      title: translations.feature1Title,
      text: translations.feature1Text,
    },
    {
      Image: images.Image2 || Image2,
      title: translations.feature2Title,
      text: translations.feature2Text,
    },
    {
      Image:
        images.Image3 ||
        (locale === "sv-fi" || locale === "sv-se" ? Image3fi : Image3se),
      title: translations.feature3Title,
      text: translations.feature3Text,
    },
  ]
  const listLength = countDefinedStrings([
    translations.feature1Title,
    translations.feature2Title,
    translations.feature3Title,
    translations.feature4Title,
  ])

  if (listLength === 4) {
    list.push({
      Image: images.Image4 || Image2,
      title: translations.feature4Title,
      text: translations.feature4Text,
    })
  }
  return (
    <div
      className={cc([
        "relative py-16 lg:py-24",
        {
          "bg-kkm-green": theme === "green",
          "bg-kkm-yellow": theme === "yellow",
          "bg-zinc-800": theme === "dark",
        },
      ])}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <H2 theme="dark" textAlign={titleAlign}>
            {translations.title}
          </H2>
        </div>

        <div className="mt-12">
          <div
            className={cc([
              "hidden gap-8 lg:grid",
              listLength === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3",
            ])}
          >
            {list.map(({ Image, title, text }, index) => (
              <ScrollAnimate delay={0.4 * index} once={false}>
                <Card
                  Image={Image}
                  title={title}
                  text={text}
                  key={title}
                  theme={theme}
                  back={index + 1}
                />
              </ScrollAnimate>
            ))}
          </div>
          <div className="block lg:hidden ">
            <div className="ml-4">
              <Slider
                slidesToShow={1}
                {...sliderSettings("white-on-black")}
                customPaging={(number) => (
                  <a>
                    <CustomPaging number={number} theme="white-on-black" />
                  </a>
                )}
                className="number-as-dot"
              >
                {list.map(({ Image, title, text }, index) => (
                  <ListItem
                    Image={Image}
                    title={title}
                    text={text}
                    theme={theme}
                    back={index + 1}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <div className="mt-6 flex animate-scale justify-center lg:mt-4">
          <Button
            label={translations.buttonLogin}
            link={appLink}
            bgStyle="green"
            size="lg"
            outbound
          />
        </div>
      </div>
    </div>
  )
}

const HowItWorksTranslations = () => {
  const {
    howItWorksTitle,
    howItWorks2Feature1Title,
    howItWorks2Feature1Text,
    howItWorks2Feature2Title,
    howItWorks2Feature2Text,
    howItWorks2Feature3Title,
    howItWorks2Feature3Text,
    buttonLogin,
  } = useTranslations()
  return (
    <HowItWorks
      translations={{
        title: howItWorksTitle,
        feature1Title: howItWorks2Feature1Title,
        feature1Text: howItWorks2Feature1Text,
        feature2Title: howItWorks2Feature2Title,
        feature2Text: howItWorks2Feature2Text,
        feature3Title: howItWorks2Feature3Title,
        feature3Text: howItWorks2Feature3Text,
        buttonLogin,
      }}
    />
  )
}

export default HowItWorksTranslations
